module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allotment-cancellation/saledeed-details/saledeed-details.component.css
// module id = ./src/app/allocation/allotment-cancellation/saledeed-details/saledeed-details.component.css
// module chunks = main